export const seoData = {
  siteName: "Laxmi Tyre and Motors",
  siteUrl: "https://laxmimotors.com",
  businessPhone: "+91 98765 43210",
  businessEmail: "info@laxmimotors.com",
  businessAddress: "Limbodi, Indore, Madhya Pradesh 452001",
  
  home: {
    title: "Laxmi Tyre & Motors - Expert Car Repair & Service in Indore | Since 2011",
    description: "Professional car repair and service center in Limbodi, Indore. Expert car denting, painting, AC repair, mechanical services, and more. 13+ years experience. Book service now!",
    keywords: "car repair Indore, car service Indore, car denting painting Indore, automobile repair Limbodi, car AC repair, car wash service, mechanical repairs, Laxmi Tyre Motors",
    canonical: "https://laxmimotors.com/"
  },
  
  services: {
    title: "Car Services in Indore - Denting, Painting, AC Repair | Laxmi Motors",
    description: "Complete car services in Indore: Car wash ₹250+, Denting & painting ₹1000+, AC repair, mechanical repairs, battery service, tyre service. Professional quality guaranteed.",
    keywords: "car services Indore, car denting painting, car AC repair service, car wash Indore, mechanical repairs, battery service, tyre service, automobile repair",
    canonical: "https://laxmimotors.com/services"
  },
  
  about: {
    title: "About Laxmi Tyre & Motors - 13+ Years Car Service Experience in Indore",
    description: "Established in 2011, Laxmi Tyre & Motors is Indore's trusted car service center. 5000+ happy customers, expert technicians, quality parts, transparent pricing in Limbodi.",
    keywords: "about Laxmi Motors, car service center Indore, automobile repair shop, car garage Indore, professional car service, established 2011",
    canonical: "https://laxmimotors.com/about"
  },
  
  contact: {
    title: "Contact Laxmi Tyre & Motors - Car Service Center in Limbodi, Indore",
    description: "Contact Laxmi Tyre & Motors for car service in Indore. Located in Limbodi. Call +91 98765 43210. Open Mon-Sat 9AM-7PM. Book your car service appointment today!",
    keywords: "contact Laxmi Motors, car service Limbodi Indore, automobile repair contact, car garage phone number, book car service appointment",
    canonical: "https://laxmimotors.com/contact"
  },
  
  testimonials: {
    title: "Customer Reviews - Laxmi Tyre & Motors Car Service Indore | 4.8★ Rating",
    description: "Read genuine customer reviews for Laxmi Tyre & Motors. 4.8/5 rating, 500+ happy customers. See what people say about our car service quality in Indore.",
    keywords: "Laxmi Motors reviews, car service reviews Indore, customer testimonials, car repair feedback, automobile service rating",
    canonical: "https://laxmimotors.com/reviews"
  },
  
  work: {
    title: "Our Work Gallery - Laxmi Tyre & Motors Completed Projects | Before & After",
    description: "See our quality work through real customer projects. Denting & painting, AC repair, mechanical work before & after photos. 12+ years experience in Indore.",
    keywords: "Laxmi Motors work gallery, car repair before after, denting painting work, completed projects Indore, automobile repair photos",
    canonical: "https://laxmimotors.com/our-work"
  }
};

export const structuredData = {
  "@context": "https://schema.org",
  "@type": "AutoRepair",
  "name": "Laxmi Tyre and Motors",
  "image": "https://laxmimotors.com/logo.jpg",
  "description": "Professional automobile repair and maintenance services in Indore since 2011. Expert car denting, painting, and comprehensive vehicle care.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Limbodi",
    "addressLocality": "Indore",
    "addressRegion": "Madhya Pradesh",
    "postalCode": "452001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "22.7196",
    "longitude": "75.8577"
  },
  "telephone": "+91 98765 43210",
  "email": "info@laxmimotors.com",
  "url": "https://laxmimotors.com",
  "openingHours": [
    "Mo-Sa 09:00-19:00",
    "Su 10:00-17:00"
  ],
  "priceRange": "₹₹",
  "paymentAccepted": ["Cash", "Credit Card", "UPI"],
  "currenciesAccepted": "INR",
  "foundingDate": "2011",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "500"
  },
  "areaServed": {
    "@type": "City",
    "name": "Indore"
  },
  "serviceType": [
    "Car Repair",
    "Car Maintenance",
    "Car Denting",
    "Car Painting",
    "Car Wash",
    "AC Repair",
    "Battery Service",
    "Tyre Service"
  ]
};